/**
 * Transaction condition matching — the same semantics the rules engine uses
 * to auto-categorize (DataContext.debouncedApplyRules), pulled out so other
 * features can match transactions against rule-style condition groups.
 * Today that's transaction-tracked goals; the shapes are identical to
 * backend/models/Rule.js.
 *
 * A condition: { field, operator, value } — field supports dot paths
 * (e.g. "merchant.name"). Groups OR together; conditions in a group AND.
 */

export const matchesCondition = (txn, cond) => {
  if (!cond || !cond.field || cond.value === undefined || cond.value === null) return false;
  const fieldValue = cond.field
    .split('.')
    .reduce((o, p) => (o != null ? o[p] : undefined), txn);
  if (fieldValue === undefined || fieldValue === null) return false;

  const value = String(cond.value);
  switch (cond.operator) {
    case 'contains':
      return String(fieldValue).toLowerCase().includes(value.toLowerCase());
    case 'equals':
      return String(fieldValue).toLowerCase() === value.toLowerCase();
    case 'startsWith':
      return String(fieldValue).toLowerCase().startsWith(value.toLowerCase());
    case 'endsWith':
      return String(fieldValue).toLowerCase().endsWith(value.toLowerCase());
    case 'greaterThan':
      return Number(fieldValue) > Number(value);
    case 'lessThan':
      return Number(fieldValue) < Number(value);
    case 'between': {
      if (!value.includes(',')) return false;
      const [min, max] = value.split(',').map(Number);
      return Number(fieldValue) >= min && Number(fieldValue) <= max;
    }
    default:
      return false;
  }
};

export const matchesConditionGroups = (txn, conditionGroups) => {
  if (!conditionGroups || conditionGroups.length === 0) return false;
  return conditionGroups.some(
    (group) =>
      group &&
      group.conditions &&
      group.conditions.length > 0 &&
      group.conditions.every((cond) => matchesCondition(txn, cond))
  );
};
